<template>
    <div>
      <ledes-list></ledes-list>
    </div>
  </template>
  <script>
  export default {};
  </script>